export type PlanningAttachmentCategory =
  | 'File'
  | 'Job Plan Packet'
  | 'Final Report';

/** Attachment category options shown in the PA/WB Attachments dialog. */
export const PA_ATTACHMENT_CATEGORY_OPTIONS: { label: string; value: string }[] = [
  { label: 'Approved Subsequent', value: 'ApprovedSubsequent' },
  { label: 'Approved WBS',        value: 'ApprovedWbs' },
  { label: 'Current Wellbore Diagram (excel)', value: 'WellboreDiagram' },
  { label: 'Current Wellbore Diagram (pdf)',   value: 'WellboreDiagramPdf' },
  { label: 'Dig Plan',            value: 'DigPlan' },
  { label: 'File',                value: 'File' },
  { label: 'Subsurface Permit',   value: 'Permit' },
  { label: 'Powerline Variance Plan',          value: 'PowerlineVariancePlan' },
  { label: 'Proposed Wellbore Diagram (pdf)',  value: 'ProposedWellboreDiagram' },
  { label: 'Rod Detail',          value: 'RodDetail' },
  { label: 'Rod and Tubing Retrieval', value: 'RodAndTubingRetrieval' },
  { label: 'Site Survey',         value: 'SiteSurvey' },
  { label: 'Title Clearance',     value: 'TitleClearancePdf' },
  { label: 'Tubulars & Rods',     value: 'TubularsRods' },
  { label: 'Waterboard Letter',   value: 'WaterboardLetter' },
  { label: 'Well History',        value: 'WellHistory' },
  { label: 'Conservation Measures', value: 'ConservationMeasures' },
  { label: 'Plat',                   value: 'Plat' },
  { label: 'Working Interest Owners', value: 'WorkingInterestOwners' },
  { label: 'Site Restore Photos',     value: 'SiteRestorePhoto' },
  { label: 'P&A Procedure',           value: 'PaProcedure' },
];

export interface PlanningAttachment {
  id: string;
  name: string;
  fileName: string;
  category: PlanningAttachmentCategory;
  uploadedBy: string;
  uploadedOn: string;
  sizeLabel: string;
  /** API attachment type key used for download URL requests (e.g. 'SupportingPicsReports', 'JobPlanPacket'). */
  attachmentType?: string;
}

export interface PlanningCorrespondence {
  id: string;
  fileName: string;
  notification: string;
  recipient: string;
  sentOn: string;
  status: string;
  hasDownload?: boolean;
}

export interface PlanningAttachmentSeed {
  attachments: PlanningAttachment[];
  correspondence: PlanningCorrespondence[];
}

export function buildPlanningAttachmentSeed(
  _caseId: string,
  _wellName: string,
): PlanningAttachmentSeed {
  return {
    attachments: [],
    correspondence: [],
  };
}